module.exports = __webpack_public_path__ + "img/1 (15).f58ef9dd.jpg";